import React from 'react';
import TextArea from '@mulesoft/anypoint-components/lib/TextArea';
import FormComponentWithValidation from '@mulesoft/exchange-ui-components/lib/components/FormComponentWithValidation';

const TextAreaWithValidation = (props) => {
  return <FormComponentWithValidation {...props} FormComponent={TextArea} />;
};

export default TextAreaWithValidation;
